import { render, staticRenderFns } from "./MainInfoColumnTurn.vue?vue&type=template&id=789d8103&scoped=true&"
import script from "./MainInfoColumnTurn.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumnTurn.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumnTurn.vue?vue&type=style&index=0&id=789d8103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d8103",
  null
  
)

export default component.exports